import { useState, useEffect } from 'react';
import { fetchComandosPendientes, deleteComando } from '../../../controller/comandoController'; // Ajusta import si fetchEquipo y fetchEmpleado están en otro archivo
import { Container, Table, Button, Modal } from 'react-bootstrap';
import { Trash } from 'react-bootstrap-icons';
import Comando from '../../../models/comando';
import { fetchEquipo } from '../../../controller/dispositivosController';
import { fetchEmpleado } from '../../../controller/empleadoController';

function ComandosPendientesView() {
  const [comandos, setComandos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [comandoToDelete, setComandoToDelete] = useState(null);

  // Estados para guardar nombres de equipos y empleados para evitar múltiples llamadas repetidas
  const [equiposNombres, setEquiposNombres] = useState({});
  const [empleadosNombres, setEmpleadosNombres] = useState({});

  useEffect(() => {
    const getComandos = async () => {
      try {
        const data = await fetchComandosPendientes();
        const comandosModelados = data.map(c => new Comando(c));
        setComandos(comandosModelados);

        // Obtener todos los IDs únicos de equipos y empleados para no hacer llamadas repetidas
        const equipoIds = [...new Set(comandosModelados.map(c => c.equipo).filter(Boolean))];
        const empleadoIds = [...new Set(comandosModelados.map(c => c.empleado).filter(Boolean))];

        // Traer nombres de equipos
        const equiposMap = {};
        await Promise.all(equipoIds.map(async (id) => {
          try {
            const equipoData = await fetchEquipo(id);
            equiposMap[id] = equipoData.name || 'N/A';
          } catch {
            equiposMap[id] = 'N/A';
          }
        }));
        setEquiposNombres(equiposMap);

        // Traer nombres de empleados
        const empleadosMap = {};
        await Promise.all(empleadoIds.map(async (id) => {
          try {
            const empleadoData = await fetchEmpleado(id);
            empleadosMap[id] = empleadoData.nombre || 'N/A';
          } catch {
            empleadosMap[id] = 'N/A';
          }
        }));
        setEmpleadosNombres(empleadosMap);

      } catch (error) {
        console.error('Error al obtener los comandos pendientes:', error);
      } finally {
        setLoading(false);
      }
    };

    getComandos();
  }, []);

  if (loading) {
    return <h1>Cargando comandos pendientes...</h1>;
  }

  const handleDeleteClick = (comando) => {
    setComandoToDelete(comando);
    setShowConfirmDelete(true);
  };

  const handleConfirmDelete = async () => {
    if (!comandoToDelete) return;
    try {
      await deleteComando(comandoToDelete.id);
      setComandos(comandos.filter(c => c.id !== comandoToDelete.id));
      setShowConfirmDelete(false);
      setComandoToDelete(null);
    } catch (error) {
      console.error('Error al eliminar el comando:', error);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmDelete(false);
    setComandoToDelete(null);
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Comandos Pendientes</h1>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Equipo</th>
            <th>Comando</th>
            <th>Empleado</th>
            <th>Creado En</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {comandos.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No hay comandos pendientes.
              </td>
            </tr>
          ) : (
            comandos.map((comando) => (
              <tr key={comando.id}>
                <td>{equiposNombres[comando.equipo] || 'Cargando...'}</td>
                <td>{comando.comando}</td>
                <td>{empleadosNombres[comando.empleado] || 'Cargando...'}</td>
                <td>{new Date(comando.creado_en).toLocaleString()}</td>
                <td>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDeleteClick(comando)}
                  >
                    <Trash color="white" />
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <Modal show={showConfirmDelete} onHide={handleCancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro que deseas eliminar el comando con ID {comandoToDelete?.id}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default ComandosPendientesView;
